import React, { useMemo, useRef } from "react";
import PropTypes from "prop-types";
import countriesData from "../../data/countries.json";

const CountrySelector = ({
  selectedCountry,
  onCountryChange,
  t,
  apiLanguageCode,
  className
}) => {
  const countrySelectRef = useRef(null);

  const priorityCountryCodes = ['CH', 'DE', 'FR', 'AT', 'IT', 'LI'];

  const countries = useMemo(() => {
    const mapped = countriesData.map(country => {
      let localizedName;

      if (country.translations[apiLanguageCode]) {
        localizedName = country.translations[apiLanguageCode].common;
      } else if (country.translations[convertLanguageCode(apiLanguageCode, 'two-letter')]) {
        localizedName = country.translations[convertLanguageCode(apiLanguageCode, 'two-letter')].common;
      } else {
        localizedName = country.name.common;
      }

      return {
        name: localizedName,
        code: country.cca2,
        isPriority: priorityCountryCodes.includes(country.cca2)
      };
    });

    return mapped.sort((a, b) => {
      if (a.isPriority && !b.isPriority) return -1;
      if (!a.isPriority && b.isPriority) return 1;
      if (a.isPriority && b.isPriority) {
        return priorityCountryCodes.indexOf(a.code) - priorityCountryCodes.indexOf(b.code);
      }
      return a.name.localeCompare(b.name);
    });
  }, [apiLanguageCode]);

  const handleCountryChange = (e) => {
    const selectedCountryCode = e.target.value;
    const selectedCountry = countries.find(c => c.code === selectedCountryCode);

    onCountryChange({
      code: selectedCountryCode,
      name: selectedCountry ? selectedCountry.name : ''
    });
  };



  return (
    <select
      ref={countrySelectRef}
      className={className}
      onChange={handleCountryChange}
      value={selectedCountry || ''}
    >
      <option disabled value="">
        {t("Order.SelectCountry")}
      </option>

      {countries.map(country => (
        <option
          key={country.code}
          value={country.code}
          style={country.isPriority ? { fontWeight: 'bold' } : {}}
        >
          {country.name} ({country.code})
        </option>
      ))}
    </select>
  );
};

CountrySelector.propTypes = {
  selectedCountry: PropTypes.string,
  onCountryChange: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  apiLanguageCode: PropTypes.string.isRequired,
  className: PropTypes.string
};
export const convertLanguageCode = (code, toFormat = 'two-letter') => {
  const languageCodeMap = {
    'DE': 'deu',
    'FR': 'fra',
    'IT': 'ita',
    'EN': 'eng',

    'deu': 'DE',
    'fra': 'FR',
    'ita': 'IT',
    'eng': 'EN',
  };

  const normalizedCode = code.toUpperCase();

  if (toFormat === 'two-letter') {
    if (normalizedCode.length === 2 && Object.keys(languageCodeMap).includes(normalizedCode)) {
      return normalizedCode;
    }

    return languageCodeMap[code.toLowerCase()] || 'EN';
  } else {
    return languageCodeMap[normalizedCode] || 'eng';
  }
};
export default CountrySelector;